interface DoPointObj {
    coupon_id?: string; // 优惠券id
    pv_for: string;
}
interface Arg {
    shop?: ObjectWithId; // 店铺优惠券
    platform?: ObjectWithId; // 平台优惠券
}
interface ObjectWithId {
    id?: string;
}
export const getCouponIdObj = ({ shop, platform }: Arg) => {
    let doPointObj: DoPointObj = { pv_for: 'selected_coupon' };
    let couponIdArr = [];
    if (shop) {
        couponIdArr.push(shop.id);
    }
    if (platform) {
        couponIdArr.push(platform.id);
    }
    // 只有提单页面才打优惠券的点
    if (couponIdArr.length) {
        doPointObj.coupon_id = couponIdArr.join(',');
    }
    return doPointObj;
};

export const getSelectedIdString = (selected: Record<string, string>) => {
    if (!selected) {
        return '';
    }
    return Object.keys(selected)
        .map((item) => selected[item])
        .sort()
        .join(',');
};
